import { useSelector } from 'react-redux';
import { OM_STAKING_MIGRATE_STATUS } from '../constants/blockchain-constants';

export const useShowOnlyOmV2 = () => {
  const migrateStatus = useSelector((state) => state.OMstake.stake.migrateStatus);
  return migrateStatus === OM_STAKING_MIGRATE_STATUS.HIDE_POOL;
};
